import * as React from 'react';

import { CreateDocumentsToSend } from '@/interfaces';
import { ContainerEmailPreview } from '@/components/screens/lawyerapp/cases/email-preview/ContainerEmailPreview';

interface DocumentPreviewModalProps {
	documentsPreviewData: Partial<CreateDocumentsToSend>[];
}

export const TemplatePreview: React.FC<DocumentPreviewModalProps> = ({
	documentsPreviewData,
}) => {
	const [htmlContent, setHtmlContent] = React.useState<string>('');
	const [stylesContent, setStylesContent] = React.useState<string>('');

	React.useEffect(() => {
		const fetchHtml = async (): Promise<void> => {
			// Get the content of the HTML file
			const response = await fetch(
				`/email-templates/client/claim-submission-approved.html`
			);
			const html = await response.text();

			// Create a DOM to render the content
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			// Extraer el div con id="principalContent"
			const contentElement = doc.querySelector('#principalContent');

			if (contentElement) {
				// Remove [Customizable] from the list
				const listItems = contentElement.querySelectorAll('li');
				listItems.forEach((item) => {
					if (item.textContent === '[Customizable]') {
						item.remove(); // Eliminar el elemento del DOM
					}
				});

				// Obtener la lista padre (ul o ol) para agregar más elementos
				const parentList =
					contentElement.querySelector('ul') ||
					contentElement.querySelector('ol');

				if (parentList) {
					// Array con más registros para agregar
					const listItems = parentList.querySelectorAll('li');
					listItems.forEach((item) => item.remove());

					// Agregar los nuevos elementos a la lista
					if (documentsPreviewData.length > 0) {
						// Keep "Retainer" word as-is
						// Add new items for each document
						documentsPreviewData.forEach((doc) => {
							const newItem = document.createElement('li');
							newItem.style.marginTop = '32px';

							const boldSpan = document.createElement('span');
							boldSpan.style.fontWeight = '700';
							boldSpan.textContent = doc.name + (doc.email_text ? ':' : '');
							newItem.appendChild(boldSpan);

							if (doc.email_text) {
								const textSpan = document.createElement('span');
								textSpan.innerHTML = ` ${doc.email_text.replaceAll(
									'\n',
									'<br/>'
								)}`; // Preserve line breaks if any
								newItem.appendChild(textSpan);
							}

							parentList.appendChild(newItem);
						});
					} else {
						// Remove the word "Retainer" by replacing with empty string (adjusts phrases like "Retainer Package" to "Package")
						contentElement.innerHTML = contentElement.innerHTML.replace(
							/Retainer Package:/g,
							''
						);
						parentList.remove();
					}
				}
			}
			setHtmlContent(contentElement?.outerHTML || '');

			// Extract styles from file
			const styleElements = doc.querySelectorAll('style');
			let extractedStyles = '';
			styleElements.forEach((style) => {
				extractedStyles += style.textContent;
			});
			setStylesContent(extractedStyles);
		};

		fetchHtml();
	}, []);

	return (
		<ContainerEmailPreview type="email">
			{/* Inject the extracted styles and add flex so it looks good in preview */}
			<style>
				{`
						${stylesContent}
						.centerAlign {
								text-align: center;
								margin: 0 auto 0 auto;
								display: flex;
								flex-direction: column;
								align-items: center;
								justify-content: center;
						}
						@media only screen and (min-width: 1700px) {
								.containerGlobal {
										background-repeat: round;
								}
						}
				`}
			</style>
			<div
				className="mb-10"
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		</ContainerEmailPreview>
	);
};
